export const ORDER_ENABLE_API_MAP = {
  0: '否',
  1: '是',
};



// WEBPACK FOOTER //
// ./src/maps/order-maps.js